import { SortableTree } from 'dnd-kit-sortable-tree';
import { FC } from 'react';
import { BiColumns } from 'react-icons/bi';
import { Tooltip } from '../../tooltip/tooltip';
import { TableProps } from '../use-table';
import { TableColumnWidgetItem } from './table-column-widget-item/table-column-widget-item';
import s from './table-column-widget.module.css';
import { useTableColumnWidget } from './use-table-column-widget';

interface Props extends Pick<TableProps, 'cols'> {
  id: string;
}

export const TableColumnWidget: FC<Props> = (props) => {
  const { treeCols, handleChangeSort } = useTableColumnWidget(props);

  return (
    <Tooltip
      wrapperClassName={s.feature}
      optionsWrapperClassName={s.popup}
      trigger={<BiColumns />}
      triggerWrapperClassName={s.trigger}
    >
      <SortableTree
        TreeItemComponent={TableColumnWidgetItem}
        items={treeCols}
        onItemsChanged={handleChangeSort}
      />
    </Tooltip>
  );
};
